export const config = {
    aozVersion: "unknown",
	productionEnv: document.location.hostname.startsWith('editor.'),
    localEnv: document.location.hostname == 'localhost' || document.location.hostname.startsWith('192'),
    baseUrl: document.location.hostname == 'localhost' || document.location.hostname.startsWith('192') 
        ? "http://" + document.location.hostname + ":3001" 
        : document.location.origin
};